/* eslint-disable no-shadow */
import React from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faDownload,
  faTrashAlt,
  faComments,
  faEdit,
  faDollarSign,
  faCalendarDay,
  faExclamation,
  faArrowAltCircleRight,
  faHandHoldingUsd,
  faStickyNote,
  faFileAlt,
  faBinoculars,
  faReply,
  faClock,
  faBars,
  faTruck,
  faCalendar,
  faPlusSquare,
  faFunnelDollar,
  faDirections,
  faLock,
  faLockOpen,
  faMoneyBill,
  faCheck,
} from '@fortawesome/free-solid-svg-icons';
import { useSelector, useDispatch } from 'react-redux';
import { updateOrder } from 'services/apiRequests/orders/update';
import { setSpinner } from 'services/store/actions/view';
import { setOrder } from 'services/store/actions/orders';
import { useAlert } from 'react-alert';
import { orderPaymentStatus } from 'services/utils/const';
import styled from 'styled-components';
import { darken } from 'polished';

const StyledButton = styled(Button)`
  background-color: ${({ theme }) => theme.blowPurple};
  border-color: ${({ theme }) => theme.blowPurple};
  &:hover {
    background-color: ${({ theme }) => darken(0.2, theme.blowPurple)};
    border-color: ${({ theme }) => theme.blowPurple};
  }
`;

const AdminButtons = ({
  order,
  setModal,
  editOrder,
  getFiles,
  getLabel,
}) => {
  const dispatch = useDispatch();
  const alert = useAlert();
  const user = useSelector((state) => state.auth.user);

  const setOrderPriority = async (priority) => {
    dispatch(setSpinner(true));
    await updateOrder(
      'priority',
      order._id,
      { priority },
      (order) => {
        dispatch(setOrder(order));
        dispatch(setSpinner(false));
      },
      () => {
        dispatch(setSpinner(false));
        alert.error('Błąd!');
      },
    );
  };

  const priceBlocking = async (isPriceBlocked) => {
    dispatch(setSpinner(true));
    await updateOrder(
      'price-blocking',
      order._id,
      { isPriceBlocked },
      (order) => {
        dispatch(setOrder(order));
        dispatch(setSpinner(false));
      },
      () => {
        dispatch(setSpinner(false));
        alert.error('Błąd!');
      },
    );
  };

  const setPaymentStatusToTransfer = async () => {
    dispatch(setSpinner(true));
    await updateOrder(
      'paymentstatus',
      order._id,
      { paymentStatus: orderPaymentStatus.TRANSFER },
      (order) => {
        dispatch(setOrder(order));
        dispatch(setSpinner(false));
        alert.success('Zaktualizowano status płatności');
      },
      () => {
        dispatch(setSpinner(false));
        alert.error('błąd!');
      },
    );
  };

  return (
    <>
      <Button variant="danger" onClick={() => setModal('_remove')}>
        <FontAwesomeIcon icon={faTrashAlt} /> Usuń
      </Button>

      <Button
        variant="outline-danger"
        onClick={() => setModal('_elementsLost')}
      >
        <FontAwesomeIcon icon={faBinoculars} /> Elementy brakujące
      </Button>

      <Button
        variant="outline-primary"
        onClick={() => setModal('_elementsToCorrect')}
      >
        <FontAwesomeIcon icon={faReply} /> Elementy do poprawy
      </Button>

      <Button
        style={{
          backgroundColor: '#6f42c1',
          borderColor: '#6f42c1',
          color: 'white',
        }}
        onClick={editOrder}
      >
        <FontAwesomeIcon icon={faEdit} /> Edytuj
      </Button>

      <Button onClick={() => setModal('_neworder')}>
        <FontAwesomeIcon icon={faPlusSquare} /> Zamów
      </Button>

      <Button variant="info" onClick={() => setModal('_status')}>
        <FontAwesomeIcon icon={faArrowAltCircleRight} /> Status
      </Button>

      <Button
        style={{
          backgroundColor: '#33cec3',
          borderColor: '#33cec3',
          color: 'black',
        }}
        onClick={() => setModal('_realizationDate')}
      >
        <FontAwesomeIcon icon={faCalendarDay} /> Zmień Datę realizacji
      </Button>

      <Button
        style={{
          backgroundColor: '#486ADC',
          borderColor: '#486ADC',
          color: 'white',
        }}
        onClick={() => setModal('_planTransport')}
      >
        <FontAwesomeIcon icon={faTruck} /> Zaplanuj transport
      </Button>

      <Button variant="primary" onClick={() => setModal('_planOrder')}>
        <FontAwesomeIcon icon={faCalendar} /> Zaplanuj zamówienie
      </Button>

      <Button variant="outline-info" onClick={() => setModal('_manHours')}>
        <FontAwesomeIcon icon={faClock} /> Roboczogodziny
      </Button>

      {order.dateSendToCNC ? (
        <Button
          style={{
            backgroundColor: '#486ADC',
            borderColor: 'orange',
            color: 'white',
          }}
          onClick={() => setModal('_backFromCNC')}
        >
          <FontAwesomeIcon icon={faEdit} /> Zatwierdź odbiór CNC
        </Button>
      ) : (
        <Button
          style={{
            backgroundColor: 'orange',
            borderColor: '#486ADC',
            color: 'white',
          }}
          onClick={() => setModal('_sendToCNC')}
        >
          <FontAwesomeIcon icon={faDirections} /> Wyślij do CNC
        </Button>
      )}

      <Button
        variant="outline-success"
        onClick={() => setModal('_ventilation')}
      >
        <FontAwesomeIcon icon={faBars} /> Wentylacja
      </Button>

      <Button variant="secondary" onClick={getFiles}>
        <FontAwesomeIcon icon={faDownload} /> Pobierz
      </Button>

      <Button variant="outline-secondary" onClick={() => getLabel()}>
        <FontAwesomeIcon icon={faStickyNote} /> Pobierz naklejkę
      </Button>
      {order.status.length === 1 &&
        order.status[0] === 'zakończone' &&
        !order.isReadyToPickUp && (
          <StyledButton onClick={() => setModal('_readyToPickUp')}>
            <FontAwesomeIcon icon={faCheck} /> Gotowe do odbioru
          </StyledButton>
        )}
      {user.isBoss && (
        <Button
          variant="success"
          onClick={() => setModal('_paymentStatus')}
        >
          <FontAwesomeIcon icon={faHandHoldingUsd} /> Status płatności
        </Button>
      )}

      <Button
        style={
          order.isPriceBlocked
            ? {
                backgroundColor: 'purple',
                borderColor: 'purple',
                color: 'white',
              }
            : {
                backgroundColor: 'white',
                borderColor: 'purple',
                color: 'purple',
              }
        }
        onClick={() => priceBlocking(!order.isPriceBlocked)}
      >
        {order.isPriceBlocked ? (
          <FontAwesomeIcon icon={faLockOpen} />
        ) : (
          <FontAwesomeIcon icon={faLock} />
        )}{' '}
        {order.isPriceBlocked ? 'Odblokuj cenę' : 'Zablokuj cenę'}
      </Button>

      <Button variant="outline-info" onClick={setPaymentStatusToTransfer}>
        <FontAwesomeIcon icon={faMoneyBill} /> Płaność przelewem
      </Button>

      <Button variant="warning" onClick={() => setModal('_changePrice')}>
        <FontAwesomeIcon icon={faDollarSign} /> Zmień cenę
      </Button>

      {/* TODO Upewnić się że zaliczka jest zablokowana gdy już istnieje */}
      <Button
        variant="outline-warning"
        onClick={() => setModal('_changeAdvancePayment')}
        disabled={!!order.advancePayment}
      >
        <FontAwesomeIcon icon={faFunnelDollar} /> Zaliczka
      </Button>

      <Button
        variant="outline-dark"
        onClick={() => setModal('_addComment')}
      >
        <FontAwesomeIcon icon={faComments} /> Dodaj komentarz
      </Button>

      <Button
        variant={order.priority ? 'outline-dark' : 'dark'}
        onClick={() => {
          setOrderPriority(!order.priority);
        }}
      >
        <FontAwesomeIcon icon={faExclamation} />{' '}
        {order.priority ? 'Usuń priorytet' : 'Nadaj priorytet'}
      </Button>

      {order.status.includes('zakończone') && (
        <Button
          variant="outline-primary"
          onClick={() => setModal('_getPickUpReport')}
        >
          <FontAwesomeIcon icon={faFileAlt} /> Protokół odbioru
        </Button>
      )}
    </>
  );
};

export default AdminButtons;
